import type { ColumnsType } from "antd/es/table";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { IInviteInfo } from "@/pages/invite-rewards/types";
import { dateFormatter } from "project-config/utils/date-formatter";

export function useTableColumn() {
  const t = getTranslateNsT("center");

  const columns: ColumnsType<IInviteInfo> = [
    {
      title: t("picture_reward_nickname"),
      dataIndex: "userName",
    },
    {
      title: t("user_com_modify_label_tel"),
      dataIndex: "phone",
    },
    {
      title: t("picture_reward_register_date"),
      dataIndex: "registerDate",
      render: (v) => dateFormatter(v),
    },
    {
      title: t("animation_recharge_status"),
      dataIndex: "rechargeStatus",
      render: (v) => t(`recharge_status_${v}`),
    },
  ];
  return { columns };
}
